import { Button, Col, Icon, Layout, Menu, Popconfirm, Row, Switch, Tabs, Tag, Typography, notification } from 'antd';
import React from 'react';
import CommonTypeProps from '../../../common/CommonTypeProps';
import { LinkO2O } from '../../../common/LinkO2O';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import { CommonResponse } from '../../../redux/model';
import { CommonNotificationSaveError, CommonNotificationUpdateSuccessfully } from '../../../shares/CommonNotification';
import { UserTokenDAL } from './dal/UserTokenDAL';
import { get } from 'lodash';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
import { GetCsrfToken, TResponseGetCsrfToken } from '@shares/hooks';

const mask = (string: string, localPartIndex: number, domainIndex: number) => {
  const length = string.length - 1;

  const arr = string.split('').map((character, i) => {
    if (i < localPartIndex || length - domainIndex < i) return character;
    return '*';
  });

  return arr.join('');
};

const maskingKey = (input: string | undefined, start: number, end: number) => {
  if (!input) {
    return '--/--';
  } else {
    let output = input;
    const replacement = mask(input, start, end);
    output = output.split(input).join(replacement);

    return output;
  }
};

interface Props extends CommonTypeProps {
  changeApiKey: any;
  getMe: any;
}

export class UserApiComponentV2 extends React.Component<Props, any> {
  state = {};

  componentDidMount = () => {
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.AccountAPI });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.AccountAPI,
        title: BIGDATA_CONSTANT.trackTitle.AccountAPI,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
  };
  timer: any;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  generateApiKey = async () => {
    this.props.setGlobalLoading(true);

    const csrfRes: TResponseGetCsrfToken = await this.props.commonActionFromDALV2(GetCsrfToken);
    const csrfToken = csrfRes.csrfToken;

    this.props.changeApiKey(csrfToken).then(() => {
      notification.success({
        message: BIGDATA_CONSTANT.message.default.title.success,
        description: 'Change Api Key success, please wait to redirect to Login page!',
        icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
      });
      setTimeout(() => {
        this.props.setGlobalLoading(false);
        this.props.history.replace('/login');
      }, 2000);
    });
  };

  onChangeStatusApiAccess = async () => {
    const result = this.props.commonActionFromDALV2(
      UserTokenDAL.updateStatusApiAccess,
      // @ts-ignore
      !this.props.user.disabledApiAccess
    );
    try {
      const res: CommonResponse = await result;
      if (res.success) {
        setTimeout(() => {
          this.props.getMe();
        }, 500);
        CommonNotificationUpdateSuccessfully();
      } else {
        CommonNotificationSaveError(res.message);
      }
    } catch (error) {
      CommonNotificationSaveError(get(error, 'message'));
    }
  };

  renderContentLayout = (version?: string) => {

    return (
      <>
        {version === 'v2' && (
          <Tabs
            defaultActiveKey='security'
            onChange={(key: string) => {
              if (key === 'my-profile') this.props.history.push({ pathname: '/my-account-info' });
              if (key === 'security') this.props.history.push({ pathname: '/security/2fa-security' });
              if (key === 'activity') this.props.history.push({ pathname: '/activity/invitation' });
            }}
          >
            <Tabs.TabPane tab='My Profile' key='my-profile' />
            <Tabs.TabPane tab='Security' key='security' />
            <Tabs.TabPane tab='Activity' key='activity' />
          </Tabs>
        )}
        <Layout>
          <Layout.Sider
            width={200}
            style={{ background: '#fff' }}
            className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
          >
            <Menu mode='inline' defaultSelectedKeys={['api']} style={{ height: '100%' }}>
              <Menu.Item key='sercurity'>
                <LinkO2O {...this.props} to={{ pathname: '/security/2fa-security' }}>
                  Two-Factor Auth
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='change-password'>
                <LinkO2O {...this.props} to={{ pathname: '/security/change-password' }}>
                  Change Password
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='api'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-api' }}>
                  API Account
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='tokens'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-tokens' }}>
                  Token
                </LinkO2O>
              </Menu.Item>
            </Menu>
          </Layout.Sider>
          <Layout.Content className='pl30 pt10'>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <Typography.Title level={4}>API Account Information</Typography.Title>
                <Row gutter={[10, 10]}>
                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Popconfirm
                      onConfirm={this.onChangeStatusApiAccess}
                      title={BIGDATA_CONSTANT.message.default.confirmText}
                    >
                      <Switch
                        // @ts-ignore
                        checked={this.props.user.disabledApiAccess}
                        checkedChildren='Yes'
                        unCheckedChildren='No'
                      />
                    </Popconfirm>
                    <span className='ml8'>Disable API Access</span>
                  </Col>
                  <Col>
                    {/* @ts-ignore */}
                    <span style={{ color: !this.props.user.disabledApiAccess ? '#32A85B' : '#E2A517' }}>
                      {/* @ts-ignore */}
                      {!this.props.user.disabledApiAccess
                        ? 'Your account has API access enabled.'
                        : 'Your account does not have API access enabled.'}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <div
                  style={{
                    display: 'inline-flex',
                    flexDirection: 'column',
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      background: '#f4f5f6',
                      padding: '8px 12px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Typography.Text>Endpoint: </Typography.Text>
                    <Typography.Text type='secondary' style={{ color: 'var(--primary-color)' }}>
                      https://account.mydatalakes.com/api/accounts/authen
                    </Typography.Text>
                    <Tag className='ant-tag-primary ml10'>POST</Tag>
                  </div>

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'max-content max-content 1fr',
                      alignItems: 'start',
                      columnGap: 8,
                      rowGap: 10,
                      background: '#f4f5f6',
                      padding: '8px 12px',
                    }}
                  >
                    <Typography.Text>username</Typography.Text>
                    <Typography.Text>:</Typography.Text>
                    <Typography.Text type='secondary' style={{ color: 'var(--primary-color)' }}>
                      {this.props.user.id}
                    </Typography.Text>

                    <Typography.Text>apiKey</Typography.Text>
                    <Typography.Text>:</Typography.Text>
                    <Typography.Text
                      type='secondary'
                      style={{ color: 'var(--primary-color)' }}
                      copyable={{ text: this.props.user.apiKey }}
                    >
                      {maskingKey(this.props.user.apiKey, 4, 0)}
                    </Typography.Text>

                    <Typography.Text>cdpKey</Typography.Text>
                    <Typography.Text>:</Typography.Text>
                    <Typography.Text
                      type='secondary'
                      style={{ color: 'var(--primary-color)' }}
                      copyable={{ text: this.props.user.orgCtx?.orgId || '' }}
                    >
                      {maskingKey(this.props.user.orgCtx?.orgId || '', 4, 0)}
                    </Typography.Text>
                  </div>

                  <div
                    style={{
                      background: '#f4f5f6',
                      padding: '8px 12px',
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      gap: 5,
                    }}
                  >
                    <Typography.Text>API KEY:</Typography.Text>
                    <Typography.Text
                      className='custom-copy-icon'
                      type='secondary'
                      style={{ color: 'var(--primary-color)' }}
                      copyable={{ text: this.props.user.apiKey }}
                    >
                      {maskingKey(this.props.user.apiKey, 0, 0)}
                    </Typography.Text>
                  </div>
                </div>
              </Col>
              <Col xs={24} className='pt15'>
                <Popconfirm
                  title='All tokens will be invalidated (including API Tokens)?'
                  onConfirm={this.generateApiKey}
                >
                  <Button type='primary'>
                    <Icon
                      component={() => (
                        <svg width='21' height='14' viewBox='0 0 21 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M16.04 13.6245C18.3356 13.6245 20.125 11.9677 20.125 9.88302C20.125 8.28638 19.2212 6.88852 17.6909 6.28605C17.733 2.86383 15.2869 0.375488 12.1659 0.375488C10.0511 0.375488 8.57501 1.52025 7.68332 2.89998C5.80348 2.29145 3.73087 3.73746 3.70676 5.89442C1.97758 6.13542 0.875 7.6477 0.875 9.52148C0.875 11.7688 2.82711 13.6185 5.4239 13.6185L16.04 13.6245ZM16.034 12.5581L5.41787 12.5521C3.42359 12.5521 1.94143 11.1723 1.94143 9.52148C1.94143 7.95501 2.88736 6.72589 4.53822 6.72589C4.63462 6.72589 4.6768 6.67166 4.6768 6.57523C4.6768 4.24959 6.40598 3.43621 8.02067 4.00256C8.11106 4.03268 8.16529 4.01461 8.21347 3.93026C8.97264 2.58065 10.1415 1.44192 12.1659 1.44192C14.7085 1.44192 16.51 3.46031 16.6546 5.84019C16.6786 6.17157 16.6546 6.5632 16.6305 6.91265C16.6244 7.00303 16.6606 7.06325 16.745 7.08133C18.1548 7.4127 19.0586 8.47313 19.0586 9.88302C19.0586 11.3832 17.7391 12.5581 16.034 12.5581Z'
                            fill='currentColor'
                          />
                          <path
                            d='M14.6784 7.9128C14.6784 6.64149 13.6602 5.62329 12.3949 5.62329C11.4309 5.62329 10.5874 6.20169 10.25 7.0994H6.68318C6.60485 7.0994 6.53858 7.12957 6.46628 7.20188L5.8698 7.79231C5.80352 7.85857 5.7975 7.96099 5.8698 8.0333L6.99648 9.17203C7.0688 9.24434 7.17122 9.24434 7.23748 9.17203L7.94841 8.44901L8.93049 9.43714C8.99077 9.5034 9.08714 9.49137 9.15945 9.42511L10.1476 8.44901C10.5935 9.56966 11.4068 10.1963 12.3949 10.1963C13.6541 10.1963 14.6784 9.17807 14.6784 7.9128ZM13.5758 7.90676C13.5758 8.29236 13.2565 8.60565 12.8709 8.60565C12.4793 8.60565 12.166 8.29236 12.166 7.90676C12.166 7.52116 12.4793 7.20786 12.8709 7.20786C13.2565 7.20786 13.5758 7.51517 13.5758 7.90676Z'
                            fill='currentColor'
                          />
                        </svg>
                      )}
                    />
                    Generate New Key
                  </Button>
                </Popconfirm>
              </Col>
            </Row>
          </Layout.Content>
        </Layout>
      </>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='my-security'
        selectedSubMenuStandard='my-security'
        selectedLeftNavModern='my-info'
        selectedSubMenuModern='my-info'
        breadcrumbItemsStandard={[
          { title: 'Home', path: '/' },
          { title: 'Security', path: '/security/2fa-security' },
          { title: 'Account API' },
        ]}
        breadcrumbItemsModern={[
          { title: 'Account', path: '/' },
          { title: 'Profile', path: '/security/2fa-security' },
          { title: 'Security' },
        ]}
        pageTitle='Profile'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
}
